export default "__VITE_ASSET__kfu3OPAE__"